import { useMutation } from "@shared/lib/hooks";
import { BackednResponse } from "@shared/lib/types";
import { IBrandOrganisation } from "@shared/lib/types/brandOrganisation";
import { ORGANISATION_LIST_QUERY_KEY } from "../constants";
import { OrganisationService } from "../services/organisation.service";

export default function useEditNotificationRecipients() {
  const {
    mutate: editNotificationRecipients,
    isLoading: isEditNotificationRecipientsLoading,
    isSuccess: isEditNotificationRecipientsSuccess,
    error: editNotificationRecipientsError,
  } = useMutation({
    mutationFn: (payload: {
      brandOrganisationId: string;
      notificationReciepents: {
        userId: string;
        isAllBrands: boolean;
        brandIds: string[];
      };
    }) => OrganisationService.editNotificationRecipients(payload),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c, data, params) => {
      c.setQueryData(
        [...ORGANISATION_LIST_QUERY_KEY, params.brandOrganisationId],
        (oldData: BackednResponse<IBrandOrganisation>) => ({
          ...oldData,
          data: {
            ...oldData?.data,
            adRightsSettings: {
              ...oldData?.data?.adRightsSettings,
              ...data.data?.adRightsSettings,
              alertNotificationReciepents: [
                ...data.data?.adRightsSettings?.alertNotificationReciepents,
              ],
            },
          },
        })
      );
    },
  });

  return {
    editNotificationRecipients,
    isEditNotificationRecipientsLoading,
    editNotificationRecipientsError,
    isEditNotificationRecipientsSuccess,
  };
}
